import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { consumablesAjax } from "../../ajax/ConsumablesAjax";
import { drillBlastReferenceAjax } from "../../ajax/DrillBlastReferenceAjax";
import { ConsumableItemDTO, ConsumableStoreDTO, DrillComponentDTO, RigShiftDTO } from "../../DTOs/DrillBlast/ConsumablesDTO";
import { DrillBlastLookupDTO } from "../../DTOs/DrillBlast/DrillBlastLookupDTO";
import { TripleShift } from "../../types/Shift";
import { LOOKUP_STALE_TIME, lookupQuery } from "./useDrillBlastLookups";

export const consumableStoresQuery = lookupQuery<ConsumableStoreDTO>(['drillBlast', 'consumableStores'], 'the stores',
  () => consumablesAjax.getStores(), 60 * 1000);

export const consumableItemsQuery = (includeInactive = false) => lookupQuery<ConsumableItemDTO>(
  ['references', 'drillBlast', 'consumableItems', includeInactive], 'the catalogue', () => consumablesAjax.getItems(includeInactive), LOOKUP_STALE_TIME);

export const removalReasonsQuery = lookupQuery<DrillBlastLookupDTO>(['references', 'drillBlast', 'removalReasons'], 'the removal reasons',
  () => drillBlastReferenceAjax.getRemovalReasons(), LOOKUP_STALE_TIME);

export const drillComponentsQuery = (includeRetired: boolean) => lookupQuery<DrillComponentDTO>(
  ['drillBlast', 'drillComponents', includeRetired], 'the components', () => consumablesAjax.getComponents(includeRetired));

export const fittableComponentsQuery = (plantId: number) => lookupQuery<DrillComponentDTO>(
  ['drillBlast', 'fittableComponents', plantId], 'the components in stock', () => consumablesAjax.getFittable(plantId));

export const rigShiftsQuery = (date: DateTime, shift: TripleShift) => lookupQuery<RigShiftDTO>(
  ['drillBlast', 'rigShifts', date.toISODate(), shift], 'the rigs on shift', () => consumablesAjax.getRigShifts(date, shift));

const NONE: never[] = [];

export const useConsumableStores = () => useQuery(consumableStoresQuery).data ?? NONE;
export const useConsumableItems = (includeInactive = false) => useQuery(consumableItemsQuery(includeInactive)).data ?? NONE;
export const useRemovalReasons = () => useQuery(removalReasonsQuery).data ?? NONE;
